export default {
  init() {
    // JavaScript to be fired on the home page
    const progress_circle = $('#progress-circle');
    progress_circle.circleProgress({
      value: 0,
      startAngle: -(Math.PI / 2),
      thickness: 3,
      fill: '#B0B3D4',
      animation: {
        duration: 50,
        easing: 'linear',
      },
    });

    const article = $('.main-stash-content');
    let buffer = 150;

    $(window).on('scroll', function() {
      // Doing this here, as height might change when going to mobile;
      let article_dist_from_top =
        article.offset().top + article.prop('clientHeight') - buffer;
      let current_scroll_pos = window.scrollY + buffer;
      let percent = Math.floor(
        (100 / article_dist_from_top) * current_scroll_pos
      );
      percent = percent > 100 ? 100 : percent;
      progress_circle.circleProgress('value', percent / 100);
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single.js